import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle, Warning, Spinner, XCircle } from "@phosphor-icons/react";

const BASE = process.env.REACT_APP_BACKEND_URL;

function OwnerDecisionPage({ decision }) {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.post(`${BASE}/api/public/alarm-addendum-${decision}/${token}`);
        setState({ loading: false, ok: true, data });
      } catch (e) {
        setState({ loading: false, ok: false,
          error: e.response?.data?.detail || "Link expired or invalid" });
      }
    })();
  }, [token, decision]);

  const isApprove = decision === "approve";
  const brandColor = isApprove ? "emerald" : "slate";

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-6" data-testid={`addendum-${decision}-page`}>
      <div className="max-w-lg w-full bg-white border-2 border-[#0f172a] p-8 shadow-2xl">
        <div className="text-[10px] font-black uppercase tracking-widest text-slate-500 mb-2">
          Field Radar · Alarm Install Addendum
        </div>
        {state.loading && (
          <div className="flex items-center gap-3 text-slate-700">
            <Spinner weight="bold" size={24} className="animate-spin"/>
            <span className="font-bold">Recording your decision…</span>
          </div>
        )}
        {!state.loading && state.ok && (
          <div className={`flex items-start gap-3 text-${brandColor}-800`}>
            {isApprove ? <CheckCircle weight="fill" size={28}/> : <XCircle weight="fill" size={28}/>}
            <div>
              <h1 className="font-display font-black text-2xl">
                {state.data.state === "already_decided"
                  ? `Already ${state.data.decision === "approved" ? "Approved" : "Declined"}`
                  : isApprove ? "Install Approved" : "Install Declined"}
              </h1>
              <p className="mt-2 text-sm text-slate-700">{state.data.message}</p>
              {isApprove && state.data.job_id && (
                <p className="mt-2 text-xs font-mono text-slate-500">
                  Job ID: {state.data.job_id.slice(0, 12)}…
                </p>
              )}
            </div>
          </div>
        )}
        {!state.loading && !state.ok && (
          <div className="flex items-start gap-3 text-red-800" data-testid={`addendum-${decision}-error`}>
            <Warning weight="fill" size={28}/>
            <div>
              <h1 className="font-display font-black text-2xl">Link Invalid</h1>
              <p className="mt-2 text-sm">{state.error}</p>
            </div>
          </div>
        )}
        <div className="mt-8 pt-4 border-t border-slate-200 text-[10px] font-black uppercase tracking-widest text-slate-400">
          Field Radar · Intelligent Property Operations
        </div>
      </div>
    </div>
  );
}

export function AlarmAddendumApprove() { return <OwnerDecisionPage decision="approve"/>; }
export function AlarmAddendumDecline() { return <OwnerDecisionPage decision="decline"/>; }
